(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["island-luxury-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const carousel = root.querySelector('[data-announcement-carousel]');
      if (!carousel || carousel.dataset.ready === 'true') return;
      const items = [...carousel.querySelectorAll('[data-announcement-item]')];
      const dots = [...carousel.querySelectorAll('[data-announcement-dot]')];
      const previous = carousel.querySelector('[data-announcement-prev]');
      const next = carousel.querySelector('[data-announcement-next]');
      if (items.length < 2) return;

      let activeIndex = 0;
      let timer;
      let touchStartX = 0;
      const interval = 5000;

      const show = (index) => {
        activeIndex = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
          const active = itemIndex === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          item.setAttribute('tabindex', active ? '0' : '-1');
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        timer = window.setInterval(() => show(activeIndex + 1), interval);
      };
      const move = (direction) => {
        show(activeIndex + direction);
        start();
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      carousel.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stop();
      }, { passive: true });
      carousel.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const distance = touchEndX - touchStartX;
        if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
        start();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      show(0);
      start();
      carousel.dataset.ready = 'true';
    };

    const initializeHero = (root) => {
      const hero = root.querySelector('[data-hero-carousel]');
      if (!hero || hero.dataset.heroReady === 'true') return;
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-hero-dot]')];
      const previous = hero.querySelector('[data-hero-prev]');
      const next = hero.querySelector('[data-hero-next]');
      if (slides.length < 2) return;

      let activeIndex = 0;
      let timer;
      let touchStartX = 0;
      const interval = Number(hero.dataset.heroInterval) || 6000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.setAttribute('tabindex', active ? '0' : '-1');
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      };

      const stop = () => window.clearInterval(timer);
      const startHero = () => {
        stop();
        if (!reducedMotion) timer = window.setInterval(() => show(activeIndex + 1), interval);
      };
      const move = (direction) => {
        show(activeIndex + direction);
        startHero();
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
        show(dotIndex);
        startHero();
      }));
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', startHero);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', startHero);
      hero.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stop();
      }, { passive: true });
      hero.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
        startHero();
      }, { passive: true });

      show(0);
      startHero();
      hero.dataset.heroReady = 'true';
    };

    const initializeAll = (root) => {
      initialize(root);
      initializeHero(root);
    };

    const start = () => document.querySelectorAll('.island-luxury-home').forEach(initializeAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
